import cache from './cache.js';
import isAndroid from './isAndroid.js';
import isIos from './isIos.js';
import isIpad from './isIpad.js';
import isBlackberry from './isBlackberry.js';
import isKindleFire from './isKindleFire.js';
import isKindle from './isKindle.js';
import isWindowsMobile from './isWindowsMobile.js';
import isWebOs from './isWebOs.js';

export default cache('isMobile', function isMobile() {
  return isAndroid() || isIos() || isIpad() || isKindleFire() || isKindle() || isBlackberry() || isWindowsMobile () || isWebOs();
});